import React from "react";

interface PageEmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description: string;
}

/**
 * Reusable empty state component for pages
 * Shows an icon, title, and description when no data is available
 */
export function PageEmptyState({ icon, title, description }: PageEmptyStateProps) {
  return (
    <div className="h-full flex items-center justify-center">
      <div className="text-center">
        {icon && <div className="text-6xl mb-4">{icon}</div>}
        <h2 className="text-xl font-medium mb-2 text-center">{title}</h2>
        <p className="text-muted-foreground text-center max-w-md">{description}</p>
      </div>
    </div>
  );
}

